import React from "react";
import { SiLinktree } from "react-icons/si";
import { FaFileDownload } from "react-icons/fa";
const SocialMedia = () => {
  return (
    <div className="app__social">
      <div>
        <a href="/AbishekUpadhyayResume.pdf" download="Abishek_Upadhyay_Resume.pdf">
          <FaFileDownload />
        </a>
      </div>
      <div>
        <a
          href="https://linktr.ee/abishek2310"
          target="_blank"
          rel="noreferrer"
        >
          <SiLinktree />
        </a>
      </div>
    </div>
  );
};

export default SocialMedia;
